'use client';
import React, { useEffect } from 'react';
import { StoreProvider, useUIContext, UIProvider } from '@castlery/shared-components';
import { Unsubscribe } from '@reduxjs/toolkit';
import { setupOrderListeners } from '@castlery/modules-order-services';
import { startAppListening } from '@castlery/shared-redux-store';
import { setupUserListeners, setupWishlistListeners } from '@castlery/modules-user-services';
import { setupProductListeners, setupReviewsListeners } from '@castlery/modules-product-services';
import { setupCompositesListeners } from '@castlery/modules-composite-services';
import { setupTrackingListeners } from '@castlery/modules-tracking-services';
import GlobalErrorBoundary from '../../components/GlobalErrorBoundary';

export const RegionLayoutClientWithListeners = ({ children }: { children: React.ReactNode }) => {
  const { modal } = useUIContext();

  useEffect(() => {
    const subscriptions: Unsubscribe[] = [
      setupOrderListeners(startAppListening),
      setupUserListeners(startAppListening, { modal }),
      setupProductListeners(startAppListening),
      setupReviewsListeners(startAppListening),
      setupWishlistListeners(startAppListening),
      setupCompositesListeners(startAppListening, { modal }),
      setupTrackingListeners(startAppListening),
    ];

    return () => subscriptions.forEach((unsubscribe) => unsubscribe());
  }, [modal]);
  return <>{children}</>;
};

export const RegionLayoutClient = ({ children }: { children: React.ReactNode }) => {
  return (
    <GlobalErrorBoundary>
      <StoreProvider>
        <UIProvider>
          <RegionLayoutClientWithListeners>{children}</RegionLayoutClientWithListeners>
        </UIProvider>
      </StoreProvider>
    </GlobalErrorBoundary>
  );
};
